import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';
/*
  Generated class for the RolresponsaveisService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class RolresponsaveisService {

  constructor(private http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public xmlRolUpload(event, idPCA) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xmlRol', file, file.name);
      let envioRolXml: string = "rolresponsaveis/inserirRol?idPca=" + idPCA;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public getRolResponsaveis(idPCA): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarPessoasPorPca/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public importarRolResponsaveisAnoAnterior(idPCA): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/carregarPessoasPcaAnterior/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarEstados(): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarEstados";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarTipoPublicacao(): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarTipoPublicacao";
    return this.utilService.getJSON(urlObtencaoDados);
  }
  public buscarCidades(): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarCidades";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarTiposTelefone() {
    let urlObtencaoDados: string = "rolresponsaveis/listarTiposTelefone";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarCargos() {
    let urlObtencaoDados: string = "cargo/listarCargosSAP";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarTiposAtos() {
    let urlObtencaoDados: string = "rolresponsaveis/listarTiposAto";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarFuncoes() {
    let urlObtencaoDados: string = "funcao/listarFuncoes";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarPessoaPorCPF(cpf) {
    let urlObtencaoDados: string = "rolresponsaveis/buscarPessoaPorCpf?cpf=" + cpf;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarCidadesPorEstado(idEstado): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarCidadesPorEstado?idEstado=" + idEstado;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarEnderecoPorCEP(cep): any {

    const cepFormatado = cep.toString().replace('-', '');
    const url = `https://viacep.com.br/ws/${cepFormatado}/json/`;

    return new Observable( (x) => {
      var request = new XMLHttpRequest();
      request.open('get', url, true);
      request.send();
      request.onload = function () {
        var data = JSON.parse(this.response);
        x.next(data)
      }
      request.onerror = function () {
        var erro = JSON.parse(this.response);
        x.error(erro);
      }
    });

    // return this.http.get(url);

    //let urlObtencaoDados: string = "https://viacep.com.br/ws/" + cep.toString().replace('-', '') + "/json/";
    // return this.utilService.getJSONExterno(urlObtencaoDados);
  }

  public buscarFuncaoPreenchida(idFuncao, idPca, idPessoa): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/buscarFuncaoPreenchida?idFuncao=" +
      idFuncao + "&idPca=" + idPca + "&idPessoa=" + idPessoa;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarResponsavel(pessoaFuncao): Observable<any> {
    let urlObtencaoDados = "rolresponsaveis/salvarPessoa";
    return this.utilService.postJSON(urlObtencaoDados, pessoaFuncao);
  }

  public excluirResponsavel(idPessoaFuncao): Observable<any> {
    let urlObtencaoDados = "rolresponsaveis/deletarPessoaFuncao/" + idPessoaFuncao;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarLista(jsonList): Observable<any> {
    let urlObtencaoDados = "rolResponsaveisExclusao/excluirLista";
    return this.utilService.postJSON(urlObtencaoDados, jsonList);
}

  public excluirContato(idContato): Observable<any> {
    let urlObtencaoDados = `rolresponsaveis/removerContato?idContato=${idContato}`;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarPeriodoFuncao(idPeriodoFuncao): Observable<any> {
    let urlObtencaoDados = "rolresponsaveis/deletarPeriodoFuncao/" + idPeriodoFuncao;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarPortaria(idPortaria): Observable<any> {
    let urlObtencaoDados = "rolresponsaveis/deletarPortaria/" + idPortaria;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public submeterModuloRol(jsonObjeto): Observable<any> {
    let urlObtencaoDados = "rolresponsaveis/submeterModulo/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }
}



// WEBPACK FOOTER //
// ./src/providers/rolresponsaveis-service.ts